import React, { useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "../styles";
import ToggleWithIcon from "Components/formControls/HookFields/ToggleWithIcon";
import CustomHorizontalBarChart from "Components/charts/CustomHorizontalBarChart";
import GenerateDonutChart from "./GenerateDonutChart";
import ToggleTabContent from "../ToggleTabContent";
import NoDataFound from "Components/widgets/NoDataFound";
import { useRecoilValue } from "recoil";
import { checkinDetailSelector } from "Recoil/Checkins/selector";
import { StarOutlineOutlined } from "@material-ui/icons";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import { NoResponseIcon } from "Assets/index";
import { Rating } from "@material-ui/lab";

const SubTableHeader = ({ data }) => {
  const classes = useStyles();
  const { isTestSurvey, checkInType } = useRecoilValue(checkinDetailSelector);
  const [isGraphSelected, setIsGraphSelected] = useState(true);

  const handleToggle = (val) => {
    setIsGraphSelected(val);
  };
  const generateQuestionsDetails = (type) => {
    switch (type) {
      // case "DESCRIPTIVE":
      //   return data?.completedUsers ? (
      //     <Box className={classes.descriptiveStatistics}>
      //       <DescriptionSummary
      //         data={data || []}
      //         completedUsers={data.completedUsers}
      //         totalUsers={data.totalUsers}
      //       />
      //     </Box>
      //   ) : (
      //     <Box textAlign="center">
      //       <NoResponseIcon />
      //       <p className="f-light-gray">No response found</p>
      //     </Box>
      //   );
      case "EMOJIRANKING":
        return data?.completedUsers ? (
          <>
            <CustomHorizontalBarChart
              data={data}
              completedUsers={data.completedUsers}
              totalUsers={data.totalUsers}
            />
          </>
        ) : (
          <Box textAlign="center">
            <NoResponseIcon />
            <p className="f-light-gray">No response found</p>
          </Box>
        );
      case "STARRANKING":
        return data?.completedUsers ? (
          <>
            <CustomHorizontalBarChart
              data={data}
              completedUsers={data.completedUsers}
              totalUsers={data.totalUsers}
            />
          </>
        ) : (
          <Box textAlign="center">
            <NoResponseIcon />
            <p className="f-light-gray">No response found</p>
          </Box>
        );
      case "YESNO":
        return data?.totalUsers ? (
          <GenerateDonutChart data={data} />
        ) : (
          <NoDataFound />
        );
      default: {
        // data.options = data.userResponsePieChart;
        return data?.completedUsers ? (
          <CustomHorizontalBarChart
            checkInType={checkInType}
            data={data}
            completedUsers={data.completedUsers}
            totalUsers={data.totalUsers}
          />
        ) : (
          // <GenerateDonutChart data={item || []} />
          <Box textAlign="center">
            <NoResponseIcon />
            <p className="f-light-gray">No response found</p>
          </Box>
        );
      }
    }
  };

  return (
    <Box className={classes.subTableHeader}>
      <Box
        // mb={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mr={4}
        mt={1}
      >
        <Box>
          <Typography variant="body2" className="font-bold font-12">
            Summary
          </Typography>
          <Typography variant="body2" className="font-12">
            {(data?.pendingUser || 0)} Pending |{" "}
            {data?.completedUsers || 0} Completed
          </Typography>
        </Box>
        {data?.questionType !== "DESCRIPTIVE" && (
          <ToggleWithIcon onChange={(val) => handleToggle(val)} />
        )}
      </Box>
      {!isTestSurvey &&
        data?.average !== null &&
        data?.questionType == "STARRANKING" &&
        data?.completedUsers && (
          <Box
            display="flex"
            alignItems="center"
            mr={10}
            justifyContent="center"
          >
            <Rating
              key={data?.average}
              name="simple-controlled"
              precision={1}
              defaultValue={data?.average}
              className={classes.avgRating}
              emptyIcon={<StarOutlineOutlined />}
            />
            <Box ml={1} className="font-12">
              {data?.average !== null ? `${data?.average.toFixed(0)}` : ""}
            </Box>
          </Box>
        )}
      {isGraphSelected && data?.questionType !== "DESCRIPTIVE" ? (
        <Box display="flex" justifyContent="center" mr={4}>
          {generateQuestionsDetails(data?.questionType)}
        </Box>
      ) : data?.completedUsers ? (
        <Box>
          <SimpleBar
            forceVisible="y"
            style={{ maxHeight: 500 }}
            data-simplebar-auto-hide="false"
          >
            <ToggleTabContent data={data} />
          </SimpleBar>
        </Box>
      ) : (
        <Box textAlign="center" pr={4}>
          <NoResponseIcon />
          <p className="f-light-gray">No response found</p>
        </Box>
      )}
    </Box>
  );
};

export default SubTableHeader;
